<template>
  <div class="download">
    <div id="mask-outer" v-if="isWeiXin">
      <div class="open-another" id="prompt-cn" v-if="isCn">
        请点击右上角，选择在浏览器中打开后下载
      </div>
      <div class="open-another" id="prompt-en" v-else>
        Please click here and select to download after opening it in the
        browser.
      </div>
      <img class="arrow" src="../../assets/images/up-arrow.png" />
      <div class="mask"></div>
    </div>
    <div class="wrapper" :style="isCn ? wrapperStyle : wrapperHwStyle">
      <!-- <img :src="img" alt="" /> -->
    </div>
    <!-- <div class="logo">
      <img :src="logo" alt="" />
    </div> -->
    <img :src="title_img" class="title" alt="" />
    <div class="btn" :class="{cn: isCn}">
      <img @click="handle" class="android-img" :src="btn" />
      <div class="tip" v-if="isCn && isTimeBefore">雷鸟Air 3S及3S Pro版APP预计6月15日上线</div>
    </div>
  </div>
</template>
<script>
import { getApk, getXrApk, frontReport } from "../../serverice/api.js";
export default {
  data () {
    return {
      isWeiXin: false,
      isCn: true,
      btn: '',
      // logo: '',
      img: '',
      title_img: '',
      isTimeBefore: false,
      wrapperStyle: {
        background: `url(${require(`../../assets/images/index_2025_10_23.png`)}) no-repeat 0% 0% / 100% auto`,
      },
      wrapperHwStyle: {
        background: `url(${require(`../../assets/images/index_2025_10_23.png`)}) no-repeat 0% 0% / 100% auto`,
      },
    };
  },
  methods: {
    WeiXin () {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    handle () {
      if (this.WeiXin()) {
        this.isWeiXin = true;
      } else {
        var u = navigator.userAgent;
        // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); //ios终端

        if (this.isCn) {
          if (isiOS) {
            // 只有国内IOS 跳转到苹果商店
            window.open('https://apps.apple.com/cn/app/%E9%9B%B7%E9%B8%9Fxr%E7%9C%BC%E9%95%9C/id6479346184?l=en-GB')
          } else {
            getApk().then((res) => {
              this.reportBott("click");
              if (res.data.code === 100000) {
                window.location.href = res.data.data[0].ossUrl;
              }
            });
          }
        } else {

          if (isiOS) {
            // IOS 跳转到苹果商店
            window.open('https://apps.apple.com/gb/app/rayneo-xr/id6504473085')
          } else {
            getXrApk(process.env.VUE_APP_CLIENTTYPE).then((res) => {
              if (res.data.code === 100000) {
                window.location.href = res.data.data[0].ossUrl;
              }
            });
          }




        }
      }
    },
    reportBott (type) {// 国内增加埋点统计
      if (type === "view") {
        frontReport("view_load");
      } else {
        frontReport("click_download");
      }
    },
  },
  mounted () {
    const url = location.hostname;
    this.isCn = location.hash !== '#/hw_test_download' && ["xr-html-o.api.leiniao.com", "test.rayneo.cn", "localhost"].find((item) => item.includes(url));//  || process.env.NODE_ENV === 'development'
    this.img = require(`../../assets/images/${process.env.VUE_APP_MODEL}.png`)
    if (this.isCn) {
      this.btn = require("../../assets/images/cn_download.png");
      // this.logo = require("../../assets/images/logo.png");
      this.reportBott("view");
      this.title_img = require("../../assets/images/title_img.png");
    } else {
      this.btn = require("../../assets/images/btn.png");
      // this.logo = require(`../../assets/images/${process.env.VUE_APP_BRAND}.png`);
      this.title_img = require("../../assets/images/title_img_hw.png");
    }

    function isBeforeJune15_2025() {
      // 获取当前时间
      const currentDate = new Date();
      
      // 创建目标日期对象（2025年6月15日）
      // 注意：月份是从0开始的，所以6月对应的是5
      const targetDate = new Date(2025, 5, 15);
      
      // 比较两个日期
      return currentDate < targetDate;
    }
    this.isTimeBefore = isBeforeJune15_2025();
  },
};
</script>

<style scoped>
.download {
  background-color: black;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.wrapper {
  position: relative;
  margin: 0 auto;
  /* background-color: black; */
  /* margin-top: 13vh; */
}
@media (max-aspect-ratio: 2/3) {
    .wrapper {
        width: 100%;
    }
}
@media (min-aspect-ratio: 2/3) and (max-aspect-ratio: 4/5) {
    .wrapper {
        width: 80%;
    }
}
@media (min-aspect-ratio: 4/5) and (max-aspect-ratio: 1/1) {
    .wrapper {
        width: 60%;
    }
}
@media (min-aspect-ratio: 1/1) and (max-aspect-ratio: 5/4) {
    .wrapper {
        width: 50%;
    }
}
@media (min-aspect-ratio: 5/4) and (max-aspect-ratio: 3/2) {
    .wrapper {
        width: 40%;
    }
}
@media (min-aspect-ratio: 3/2) {
    .wrapper {
        width: 30%;
    }
}

.wrapper>img {
  width: 100%;
  display: inline-block;
  margin-top: 13vh;
}

/* .logo {
  position: absolute;
  top: 17px;
  left: 17px;
}

.logo>img {
  width: 79px;
} */

.title {
  position: absolute;
  top: 72px;
  width: 200px;
}

.btn {
  position: fixed;
  bottom: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  flex-direction: column;
  width: 100%;
}
  .btn.cn {
    bottom: 154px;
  }

.btn img {
  width: 79%;
  max-width: 296px;
}
.btn .tip {
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  margin-top: 8px;
  font-family: PingFang SC;
}

#mask-outer {
  position: fixed;
  z-index: 99;
  width: 100vw;
  height: 100vh;
}

.open-another {
  position: relative;
  width: 64.44vw;
  padding-top: 14.44vw;
  margin: 0 auto;
  z-index: 100;
  text-align: center;
  font-size: 3.33vw;
  color: #fff;
}

.arrow {
  position: absolute;
  width: 6.7vw;
  z-index: 100;
  top: 13vw;
  right: 6vw;
}

.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  background-color: #000;
  opacity: 0.6;
}
</style>
